import PropTypes from 'prop-types';
import styled from 'styled-components';
import { buildStyledComponent, px2rem } from 'decisiv-ui-utils';

/* istanbul ignore next */
const styles = props => `
  color: ${props.theme.colors.base.text};
  margin-right: ${px2rem(5)};
  .fa {
    font-size: ${px2rem(15)};
  }
`;

const themePropTypes = {
  colors: PropTypes.shape({
    base: PropTypes.shape({
      text: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default buildStyledComponent(
  'RepairInstructionsIconWrapper',
  styled.span,
  styles,
  { themePropTypes },
);



// WEBPACK FOOTER //
// ./compositions/DiagnosticsWidget/DiagnosticsComponent/CaseFault/RepairInstructionsIconWrapper.js